import React, { useEffect, useState } from 'react'
import { logoAltera } from '../../images/index.js'
import MenuSidebar from './menuSidebar'
import MenuLogged from './menuLogged'
import { useLocation, useNavigate } from 'react-router-dom'
import { MenuItem } from '@mui/material'
import { Link } from 'react-router-dom'
import { MENU_OPTIONS } from '../../helpers/options/options'
import { useTranslation } from 'react-i18next'
import { useWindowSize } from '../../helpers/hooks/hookWindowsSize'

/**
 * Navbar: this is a component that returns the top menu
 *@function
 */

const Navbar = () => {
  const userName = sessionStorage.getItem('user_name')
  const [showMenuSidebar, setShowMenuSidebar] = useState(false)
  const [showMenuSidebarPrincipal, setShowMenuSidebarPrincipal] =
    useState(false)
  const [showMenuLogged, setShowMenuLogged] = useState(false)
  const [userLogged, setUserLogged] = useState(false)
  const [initialUserName, setInitialUserName] = useState('')

  const { t } = useTranslation()
  let location = useLocation()
  const path = location.pathname
  let navigate = useNavigate()
  const principalPage = '/'
  let menuCompleted = ['/login', '/sign-up']
  const sizeWidth = useWindowSize().width

  /** the login and sign up views do not have the top menu */
  const showMenu = !menuCompleted.includes(path)

  /** there is a menu when the user is logged and a menu when the circle name is clicked  */
  const handleClicked = (event: MouseEvent) => {
    let element = (event.target as HTMLElement).id.split('-')[0]
    if (element !== 'MenuItem') {
      if (showMenuLogged) setShowMenuLogged(false)
      if (showMenuSidebar) setShowMenuSidebar(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClicked)
    return () => document.removeEventListener('mousedown', handleClicked)
  })

  useEffect(() => {
    if (userName) {
      setUserLogged(true)
      setInitialUserName(userName[0].toLocaleUpperCase())
    }
  }, [userName])

  /** this menu options appear when the circle name is clicked  */
  const handleShowMenuSidebar = () => {
    setShowMenuSidebar(!showMenuSidebar)
  }

  /** this is the principal menu options and it is on the left  */
  const handleShowMenuSidebarPrincipal = () => {
    setShowMenuSidebarPrincipal(!showMenuSidebarPrincipal)
  }

  /** this is the menu when the user is logged  */
  const handleShowMenuLogged = () => {
    setShowMenuLogged(!showMenuLogged)
  }

  /** go to home when the logo is clicked  */
  const redirectToPrincipalPage = () => {
    navigate(principalPage)
    navigate(0)
  }

  const goTo = (url: string) => {
    navigate(url)
  }

  /** the div with the logo that is placed is the top menu  */
  const MenuLogo = () => {
    return (
      <div key="menu-logo" className="menu-logo">
        <img
          src={logoAltera}
          alt="Logo"
          className="img-logo-altera"
          onClick={() => redirectToPrincipalPage()}
        />
      </div>
    )
  }

  const handleMenuClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    target: string
  ) => {
    e.preventDefault()
    const section = document.querySelector(target)

    if (section) {
      section.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }

  const handleHide = (hide: boolean) => {
    setShowMenuSidebar(hide)
    setShowMenuSidebarPrincipal(hide)
  }
  /** these are the option for the top menu  */
  const MenuOptions = () => {
    return (
      <>
        <div key="menu-options" className="menu-options">
          {MENU_OPTIONS.map((value, index) => {
            return (
              <MenuItem
                className={`${value.to === path ? value.class : 'menu-item'}`}
                key={`MenuItem-options-${index}`}
                component={Link}
                to={`${value.to}`}
                onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
                  handleMenuClick(e, value.section)
                }
              >
                {`${t(value.label)}`}
              </MenuItem>
            )
          })}
        </div>
      </>
    )
  }
  /** this is the cicle with the initial of the users name */
  const CircleName = () => {
    return (
      <>
        <div className="wrapper-circle">
          <div id="nav-icon" onClick={handleShowMenuSidebar}>
            <div
              className="circle-user-initials-navbar"
              onClick={handleShowMenuLogged}
            >
              {initialUserName}
            </div>
          </div>
        </div>
        <div className="menu-div-3">{showMenuLogged && <MenuLogged />}</div>
      </>
    )
  }

  /** these are the 2 options fot login and sign up */
  const LoginSignUpButtonLinks = () => {
    return (
      <>
        <div className="container-buttton-menu">
          <button
            className="button-transparent-menu"
            type="submit"
            onClick={() => goTo('/plans')}
          >
            {`${t('GET_A_QUOTE')}`}
          </button>
          <button
            className="button-seventh margin-right-2  margin-left-2"
            type="submit"
            onClick={() => goTo('/sign-up')}
          >
            {`${t('SIGN_UP')}`}
          </button>
          <button
            className="button-first width-auto"
            type="submit"
            onClick={() => goTo('/login')}
          >
            {`${t('LOGIN')}`}
          </button>
        </div>
      </>
    )
  }

  /** this is the menu hamburger fot the right side*/
  const MenuHamburger = () => {
    return (
      <>
        <div id="menu-hamburger" className="wrapper">
          <div
            id="nav-icon"
            className={`${showMenuSidebar ? 'open' : ''}
         ${
           userLogged
             ? 'position-relative hamburguer-color w-25'
             : 'position-absolute hamburguer-color'
         }`}
            onClick={handleShowMenuSidebar}
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {showMenuSidebar && (
          <MenuSidebar principal={false} handleHide={handleHide} />
        )}
      </>
    )
  }

  /** this is the menu hamburguer for the left side with the principals options */
  const MenuHamburgerPrincipal = () => {
    return (
      <>
        <div className="">
          <div id="menu-hamburger" className="wrapper-principal">
            <div
              id="nav-icon"
              className={`hamburguer-color ${
                showMenuSidebarPrincipal ? 'open' : ''
              }`}
              onClick={handleShowMenuSidebarPrincipal}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>

        {showMenuSidebarPrincipal && (
          <MenuSidebar principal={true} handleHide={handleHide} />
        )}
      </>
    )
  }

  return (
    <>
      <div className="menu-container">
        <>
          {!userLogged && (
            <div className="menu-div-1">
              <MenuLogo />
            </div>
          )}

          {!userLogged && sizeWidth > 768 && showMenu && (
            <div className="menu-div-2">
              <>
                <MenuOptions />
                <LoginSignUpButtonLinks />
              </>
            </div>
          )}

          {!userLogged && sizeWidth <= 768 && showMenu && <MenuHamburger />}

          {userLogged && sizeWidth > 768 && <CircleName />}

          {userLogged && sizeWidth <= 768 && (
            <>
              <MenuHamburgerPrincipal />
              <CircleName />
            </>
          )}
        </>
      </div>
    </>
  )
}
export default Navbar
